import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Loader from "./components/Loader";

import Booking from "./pages/Booking";

const ProgressLoader = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 15;
        });
      }, 100);
      return () => clearInterval(interval);
    } else {
      setProgress(100);
      setTimeout(() => setProgress(0), 500);
    }
  }, [isLoading]);

  if (!isLoading && progress === 0) return null;

  return (
    <div style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 9999 }}>
      <div
        style={{
          height: "3px",
          backgroundColor: "#00D084",
          width: `${progress}%`,
          transition: "all 0.3s ease-out",
          boxShadow: "0 0 10px rgba(0, 208, 132, 0.5)",
        }}
      />
    </div>
  );
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

const usePageTransition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return isLoading;
};

function PageWrapper() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const isLoading = usePageTransition();

  // Initialize AOS globally
  useEffect(() => {
    if (window.AOS) {
      window.AOS.init();
      window.AOS.refresh();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/") {
      setLoading(true);
      const handleLoad = () => setLoading(false);
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    } else {
      setLoading(false);
    }
  }, [location.pathname]);

  return (
    <>
      <ProgressLoader isLoading={isLoading} />
      <ScrollToTop />

      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
      
      <Footer />

      {loading && location.pathname === "/" && <Loader />}
    </>
  );
}

function App() {
  return (
    <Router>
      <PageWrapper />
    </Router>
  );
}

export default App;
